export const CURRENT_USER = "currentUser";
export const IS_LOGGED_IN = "isLoggedIn";
export const TOKEN = "token";
export const DEBOUNCE_TIME_LIST_SEARCH=1000
